import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("g", { filter: "url(#filter0_d_11512_209219)" }, [
  /*#__PURE__*/_createVNode("rect", {
    x: "8",
    y: "8.66968",
    width: "30",
    height: "30",
    rx: "4.28571",
    fill: "#B82025"
  }),
  /*#__PURE__*/_createVNode("rect", {
    x: "6.5",
    y: "7.16968",
    width: "33",
    height: "33",
    rx: "5.78571",
    stroke: "white",
    "stroke-width": "3",
    fill: "#B82025"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("mask", {
  id: "mask0_11512_209219",
  style: {"mask-type":"alpha"},
  maskUnits: "userSpaceOnUse",
  x: "8",
  y: "8",
  width: "30",
  height: "31"
}, [
  /*#__PURE__*/_createVNode("rect", {
    x: "8",
    y: "8.66968",
    width: "30",
    height: "30",
    rx: "4.28571",
    fill: "#FF0000"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("g", { mask: "url(#mask0_11512_209219)" }, [
  /*#__PURE__*/_createVNode("circle", {
    cx: "37.4643",
    cy: "13.4911",
    r: "14.4643",
    fill: "#C64D51"
  }),
  /*#__PURE__*/_createVNode("circle", {
    cx: "4.24993",
    cy: "37.0624",
    r: "21.9643",
    fill: "#E13E49"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("g", { filter: "url(#filter1_d_11512_209219)" }, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M15.1429 13.6697C13.9594 13.6697 13 14.6291 13 15.8125V31.5268C13 32.7102 13.9594 33.6697 15.1429 33.6697H30.8571C32.0406 33.6697 33 32.7102 33 31.5268V15.8125C33 14.6291 32.0406 13.6697 30.8571 13.6697H15.1429Z",
    fill: "white"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M26.0048 20.7045V13.6697H19.9954V20.7045C19.9954 20.891 20.0745 21.07 20.2154 21.2019C20.3562 21.3338 20.5473 21.408 20.7465 21.408H25.2536C25.4528 21.408 25.6439 21.3338 25.7848 21.2019C25.9257 21.07 26.0048 20.891 26.0048 20.7045ZM26.4064 28.6331C25.9132 28.6331 25.5135 29.033 25.5135 29.526C25.5135 30.0191 25.9132 30.4188 26.4064 30.4188H29.2827C29.7757 30.4188 30.1755 30.0191 30.1755 29.526C30.1755 29.033 29.7757 28.6331 29.2827 28.6331H26.4064Z",
    fill: "#EABCBE"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("defs", null, [
  /*#__PURE__*/_createVNode("filter", {
    id: "filter0_d_11512_209219",
    x: "1",
    y: "1.66968",
    width: "44",
    height: "44",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, [
    /*#__PURE__*/_createVNode("feFlood", {
      "flood-opacity": "0",
      result: "BackgroundImageFix"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      result: "hardAlpha"
    }),
    /*#__PURE__*/_createVNode("feOffset"),
    /*#__PURE__*/_createVNode("feGaussianBlur", { stdDeviation: "2" }),
    /*#__PURE__*/_createVNode("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0.721569 0 0 0 0 0.12549 0 0 0 0 0.145098 0 0 0 0.5 0"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in2: "BackgroundImageFix",
      result: "effect1_dropShadow_11512_209219"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in: "SourceGraphic",
      in2: "effect1_dropShadow_11512_209219",
      result: "shape"
    })
  ]),
  /*#__PURE__*/_createVNode("filter", {
    id: "filter1_d_11512_209219",
    x: "7.28571",
    y: "13.6697",
    width: "31.4286",
    height: "31.4286",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, [
    /*#__PURE__*/_createVNode("feFlood", {
      "flood-opacity": "0",
      result: "BackgroundImageFix"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      result: "hardAlpha"
    }),
    /*#__PURE__*/_createVNode("feOffset", { dy: "5.71429" }),
    /*#__PURE__*/_createVNode("feGaussianBlur", { stdDeviation: "2.85714" }),
    /*#__PURE__*/_createVNode("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in2: "BackgroundImageFix",
      result: "effect1_dropShadow_11512_209219"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in: "SourceGraphic",
      in2: "effect1_dropShadow_11512_209219",
      result: "shape"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6
  ]))
}